import React from "react";
import { useLoaderData } from "react-router-dom";
import { Box, Button, HStack } from "@chakra-ui/react";
import client from "../../../../helpers/Client";
import request2APIParams from "../../../../helpers/request2APIParams";
import Link from "../../../../components/Link";

import TicketListTableView from "./TicketListTableView";

export async function ticketsLoader({ request }) {
  try {
    const params = request2APIParams(request);
    params["page"] = params["page"] || 1;
    try {
      const ps = parseInt(window.localStorage.getItem('settings.list.pageSize') || '0', 10);
      if (ps && ps > 0) params["page_size"] = ps;
    } catch (_) { }
    console.log('Tickets API request params:', params);

    const ticketsResponse = await client.get(`/tickets/`, { params });
    console.log('Tickets API response:', ticketsResponse);
    console.log('Tickets data:', ticketsResponse.data);

    const tickets = ticketsResponse.data;
    const expectations = (await client.get("/config/expectations/")).data;
    localStorage.setItem("ticketExpectations", JSON.stringify(expectations.data));
    setTimeout(() => { localStorage.removeItem("ticketExpectations"); }, 10000);
    return [params, tickets];
  } catch (error) {
    console.error('Tickets loader error:', error);
    console.error('Error details:', error.response?.data);
    // Return empty data structure to prevent crashes
    return [{}, { results: [], count: 0, num_of_pages: 1, current_page: 1 }];
  }
}
export async function completedticketsLoader({ request }) {
  const params = request2APIParams(request);
  const tickets = (await client.get(
    "/tickets/?assigned_to=&is_unassigned=false&number=&customer=&unit=&state=completed",
    { params }
  )).data;
  const expectations = (await client.get("/config/expectations/")).data;
  localStorage.setItem("ticketExpectations", JSON.stringify(expectations));
  setTimeout(() => {
    localStorage.removeItem("ticketExpectations");
  }, 10000);
  return [params, tickets];
}
export default function Tickets() {
  const data = useLoaderData()[1];
  return (
    <Box>
      <HStack mb={4} spacing={3} justify="flex-end">
        <Button as={Link} to="/is-emri/olustur/" colorScheme="blue" variant="outline">
          İş Emri Oluştur
        </Button>
        <Button as={Link} to="/is-emri/ekibime/olustur/" colorScheme="blue">
          Kendi Ekibime İş Oluştur
        </Button>
      </HStack>
      <TicketListTableView tickets={data} />
    </Box>
  );
}
